import React from 'react'
import { connect } from 'react-redux'
import * as Redux from '../../../../components/redux'

class CStatisticIframe extends React.Component {

  constructor(props) {
    super(props)
  } 

  render() {

    const { url } = this.props

    return (
        <div className="iframe-cont">
            <button onClick={() => { this.props.onClose() }} className="iframe-close"><i className="fas fa-times" /></button>

            <iframe 
            style={{ width: "100%", height: "100%" }} src={url}></iframe>

        </div>
    );
  }
}

const msp = (state) => {
  return {
      config: state.config
  }
}

export default connect(msp)(CStatisticIframe)
